import { useState } from "react";
import { RAFFLES_PER_PAGE } from "./constants";
import { useClampPage } from "./useClampPage";

// Списки фильтруются и сортируются на клиенте — и делятся на страницы тоже.
export const useClientPage = <Item>(items: Item[]) => {
  const [page, setPage] = useState(1);
  const pages = Math.ceil(items.length / RAFFLES_PER_PAGE);

  useClampPage(page, pages, setPage);

  const start = (page - 1) * RAFFLES_PER_PAGE;
  return {
    pageItems: items.slice(start, start + RAFFLES_PER_PAGE),
    page,
    pages,
    setPage,
  };
};
